import React, {useCallback, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Chatbot} from '@robylon/web-react-sdk'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {toSHA256} from '../../utils/gtm-utils'

const hashEmail = async (email) => {
    if (!email || typeof window === 'undefined' || !window.crypto?.subtle) {
        return undefined
    }
    const normalized = email.trim().toLowerCase()
    const hashed = await toSHA256(normalized)
    return hashed || undefined
}

const RobylonChatbot = ({apiKey}) => {
    const {data: customer} = useCurrentCustomer()
    const [hashedUserId, setHashedUserId] = useState(undefined)

    const handleChatbotEvent = useCallback(() => {}, [])

    const isRegistered = customer?.isRegistered
    const email = customer?.email

    useEffect(() => {
        let isMounted = true
        if (isRegistered && email) {
            hashEmail(email).then((hashed) => {
                if (isMounted) setHashedUserId(hashed)
            })
        } else {
            setHashedUserId(undefined)
        }
        return () => {
            isMounted = false
        }
    }, [isRegistered, email])

    if (!apiKey) return null

    const userProfile = isRegistered
        ? {
              name: [customer.firstName, customer.lastName].filter(Boolean).join(' '),
              email,
              mobile: customer.phoneHome || customer.phoneMobile || undefined
          }
        : undefined

    return (
        <Chatbot
            api_key={apiKey}
            user_id={hashedUserId}
            user_profile={userProfile}
            onEvent={handleChatbotEvent}
        />
    )
}

RobylonChatbot.propTypes = {
    apiKey: PropTypes.string
}

export default RobylonChatbot